import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { ShoppableVideo, VideoShoppableProps } from './Video.Shoppable';

export interface StandaloneShoppableVideoProps extends StandaloneComponentProps {
  mediaId: VideoShoppableProps['mediaId'];
}

export const StandaloneShoppableVideo: StandaloneComponent<StandaloneShoppableVideoProps> = ({ mediaId, ...props }) => {
  return <ShoppableVideo mediaId={mediaId} {...props} />;
};

export default StandaloneShoppableVideo;
